import React, { FunctionComponent } from "react";
import { HeadProps } from "../../interfaces/interfaces";
import SEO from "../seo";
import Schema from "./schema";

interface HProps extends HeadProps {
  noSchema?: boolean;
}

const Head: FunctionComponent<HProps> = (props) => {
  return <SEO title={props.title}>{props.noSchema || <Schema />}</SEO>;
};

export default Head;
